import { Gift } from "lucide-react";

const WHATSAPP_MIMO = "https://wa.me/556193761185?text=AMEI%20A%20FESTA%20-%20Vim%20pelo%20site%20e%20quero%20meu%20mimo%20exclusivo!";

export default function FinalCTA() {
  return (
    <section
      id="contato"
      data-testid="final-cta-section"
      className="relative py-24 overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0 bg-[#1a1a1a]">
        <div className="absolute inset-0 bg-gradient-to-br from-[#E4077B]/20 via-transparent to-[#00929A]/20" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-12 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#E4077B]/20 mb-8">
          <Gift size={28} className="text-[#E4077B]" />
        </div>

        <h2
          className="text-3xl sm:text-4xl lg:text-5xl font-light text-white tracking-tight leading-tight mb-4"
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          Ei, você chegou até aqui...
        </h2>
        <p className="text-xl text-[#E4DCCC] font-light mb-8" style={{ fontFamily: "Outfit, sans-serif" }}>
          Clientes que vêm através do site ganham um mimo exclusivo!
        </p>

        <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 md:p-12 max-w-2xl mx-auto mb-8 border border-white/10">
          <p className="text-white/80 text-base mb-6">
            Entre em contato e mande a palavra mágica:
          </p>
          <div className="inline-block bg-[#E4077B] px-8 py-3 rounded-full mb-6">
            <p className="text-white text-lg font-medium tracking-wide" style={{ fontFamily: "Outfit, sans-serif" }}>
              "AMEI A FESTA"
            </p>
          </div>
          <p className="text-white/60 text-sm max-w-md mx-auto">
            A Amine preparou algo especial pra quem sonha com uma festa sem dor de cabeça e com muito comprometimento envolvido.
          </p>
        </div>

        <a
          href={WHATSAPP_MIMO}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="final-cta-whatsapp-btn"
          className="inline-flex items-center justify-center gap-2 bg-[#E4077B] hover:bg-[#c8066a] text-white px-10 py-4 rounded-full text-base font-medium transition-all duration-300 hover:shadow-xl hover:shadow-[#E4077B]/30"
        >
          Garantir Meu Mimo Exclusivo
        </a>

        <p className="text-white/40 text-sm mt-8">
          Vamos transformar sua ideia em um momento inesquecível?
        </p>
      </div>
    </section>
  );
}
